// @core/api/endpoints/chat/add_reaction.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddReactionRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Add reaction to message
 * Adds an emoji reaction to a message. Each user can add multiple different reactions but only one of each emoji type.
 */
export async function AddReaction(
  conversation_id: string,
  message_id: string,
  data: AddReactionRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages/:message_id/reactions`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':message_id', encodeURIComponent(message_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
